function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isBefore, startOfDay } from 'date-fns';
import Decimal from 'decimal.js';
import { RefundStatusTypeEnumDTO } from 'anchor-ts-infra/src/dto/payment/dto';
import { InvoiceDisplayStatus, InvoicePaymentDisplayStatusType } from 'anchor-scout-common/types';
import { InvoiceAccountingIntegration } from "../InvoiceAccountingIntegration";
import { InvoiceIntegrationModel, InvoiceIntegrationStatus } from "../InvoiceIntegrationModel";
import { InvoiceStatus } from "./model";
export function setVoided(invoice, userId) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    status: {
      type: InvoiceStatus.Voided,
      voided: {
        userId
      }
    },
    displayStatus: InvoiceDisplayStatus.Voided,
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.None
    }
  });
}
export function setRefundRequested(invoice, userId, reason) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.RefundRequested,
      userId,
      reason
    }
  });
}
export function setRefunded(invoice, timestamp, now) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    status: {
      type: InvoiceStatus.Refunded,
      refunded: {
        timestamp
      }
    },
    displayStatus: InvoiceDisplayStatus.Refunded,
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.Refunded,
      timestamp
    },
    xeroIntegration: new InvoiceAccountingIntegration(new InvoiceIntegrationModel({
      status: InvoiceIntegrationStatus.RefundRecorded,
      date: now.getTime()
    }), invoice.xeroIntegration.isSynced()),
    integration: new InvoiceIntegrationModel({
      status: InvoiceIntegrationStatus.RefundRecorded,
      date: now.getTime()
    })
  });
}
export function setPartialRefundRequested(_ref) {
  let {
    invoice,
    userId,
    reason,
    refundAmount: _refundAmount,
    refundFees: _refundFees
  } = _ref;
  return _objectSpread(_objectSpread({}, invoice), {}, {
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.RefundRequested,
      userId,
      reason
    }
  });
}
export function setPartiallyRefunded(invoice, refund) {
  var _invoice$payment, _payment$creditCardFe;
  const refunds = ((_invoice$payment = invoice.payment) === null || _invoice$payment === void 0 ? void 0 : _invoice$payment.refunds()) || [];
  const hasRefunds = refunds.length > 0;
  const lastRefund = refunds[refunds.length - 1];
  const payment = invoice.payment;
  const creditCardFeesAmount = payment && ((_payment$creditCardFe = payment.creditCardFees()) === null || _payment$creditCardFe === void 0 ? void 0 : _payment$creditCardFe.feesAmount);
  const refundNumber = hasRefunds ? lastRefund.amounts.refundNumber + 1 : 1;
  const refundAmount = new Decimal(refund.refundAmount);
  const remainingAmount = hasRefunds ? new Decimal(lastRefund.amounts.remainingAmount).sub(refundAmount.mul(100)) : refund.rawTotalAmount.sub(refundAmount).mul(100);
  const feesRatio = refundAmount.div(refund.rawTotalAmount);
  const refundFees = refund.refundFees && creditCardFeesAmount ? new Decimal(creditCardFeesAmount).mul(feesRatio) : new Decimal(0);
  const remainingFees = refund.refundFees && creditCardFeesAmount ? hasRefunds ? new Decimal(lastRefund.amounts.remainingFees).sub(refundFees.mul(100)) : new Decimal(creditCardFeesAmount).sub(refundFees) : new Decimal(0);
  const newRefund = {
    refundStatus: RefundStatusTypeEnumDTO.Refunded,
    refundFailed: undefined,
    timestamp: refund.timestamp,
    reason: refund.reason,
    userId: refund.userId,
    refundId: undefined,
    amounts: {
      refundAmount: refundAmount.mul(100).toNumber(),
      refundFees: refundFees.mul(100).toNumber(),
      remainingAmount: remainingAmount.toNumber(),
      remainingFees: remainingFees.toNumber(),
      totalRefundAmount: refundAmount.add(refundFees).mul(100).toNumber(),
      refundNumber
    }
  };
  return _objectSpread(_objectSpread({}, invoice), {}, {
    status: {
      type: InvoiceStatus.PartiallyRefunded,
      partiallyRefunded: {
        timestamp: refund.timestamp
      }
    },
    displayStatus: InvoiceDisplayStatus.PartiallyRefunded,
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.Refunded,
      timestamp: refund.timestamp
    }
  }, invoice.payment ? {
    payment: invoice.payment.addRefund(newRefund)
  } : {});
}
export function setPending(invoice, now) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    status: {
      type: InvoiceStatus.Pending
    },
    displayStatus: isBefore(startOfDay(invoice.rawDueDate), startOfDay(now)) ? InvoiceDisplayStatus.Overdue : InvoiceDisplayStatus.Issued,
    paymentDisplayStatus: {
      type: InvoicePaymentDisplayStatusType.None
    }
  });
}
export function setPaymentConfirmed(invoice, isVendor) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    status: {
      type: InvoiceStatus.PaymentConfirmed
    },
    displayStatus: InvoiceDisplayStatus.PaymentInitiated,
    paymentDisplayStatus: isVendor ? {
      type: InvoicePaymentDisplayStatusType.Collected
    } : {
      type: InvoicePaymentDisplayStatusType.None
    }
  });
}
export function setIntegration(invoice, integration) {
  return _objectSpread(_objectSpread({}, invoice), {}, {
    integration
  });
}
export function setXeroIntegration(invoice, integration) {
  const xeroIntegration = new InvoiceAccountingIntegration(integration, invoice.xeroIntegration.isSynced());
  return _objectSpread(_objectSpread({}, invoice), {}, {
    xeroIntegration
  });
}
export function setApprovalMethod(invoice, approvalMethod) {
  if (invoice.status.type === InvoiceStatus.RequiresPaymentApproval) {
    return _objectSpread(_objectSpread({}, invoice), {}, {
      status: _objectSpread(_objectSpread({}, invoice.status), {}, {
        requiresPaymentApproval: _objectSpread(_objectSpread({}, invoice.status.requiresPaymentApproval), {}, {
          approvalMethod
        })
      })
    });
  }
  return invoice;
}